import React, { useCallback } from "react";
import { Checkbox } from "../../common/UIComponents";
import { legSelectionStore } from "./legSelectionStore";
import { useLegSelection } from "./LegSelectionContext";
import { useLegStoreState } from "./useLegStore";

const LEG_LABELS = { PICKUP: "P", DELIVERY: "D" };
const LEG_COLORS = { PICKUP: "#FF2D78", DELIVERY: "#0F8D60" };

const LegHeaderCell = ({ locationType }) => {
  const { isLegWise, onHeaderToggle, getVisibleRowsWithLeg } = useLegSelection();
  // Subscribe so checkbox re-derives on store changes.
  useLegStoreState();

  const rowsWithLeg = isLegWise ? getVisibleRowsWithLeg(locationType) : [];

  const selectedCount = rowsWithLeg.reduce((acc, r) => {
    return acc + (legSelectionStore.getLegSnapshot(r.orderId, locationType) === r.locationId ? 1 : 0);
  }, 0);

  const total = rowsWithLeg.length;
  const allSelected = total > 0 && selectedCount === total;
  const indeterminate = selectedCount > 0 && selectedCount < total;

  const handleChange = useCallback(() => {
    onHeaderToggle(locationType, rowsWithLeg);
  }, [onHeaderToggle, locationType, rowsWithLeg]);

  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
      {isLegWise && total > 0 && (
        <Checkbox
          checked={allSelected}
          indeterminate={indeterminate}
          onChange={handleChange}
          onClick={(e) => e.stopPropagation()}
        />
      )}
      <span style={{ color: LEG_COLORS[locationType], fontWeight: 600 }}>{LEG_LABELS[locationType] || ""}</span>
    </span>
  );
};

export default LegHeaderCell;
